import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import { ColorPickerService, Cmyk } from 'ngx-color-picker';


/**
 * Generated class for the EditgrouppoiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editgrouppoi',
  templateUrl: 'editgrouppoi.html',
})
export class EditgrouppoiPage {
  poigr: any
  Title = ''
  boja: boolean = false
  cb: any;


  name = ''

  public toggle: boolean = false;

  public rgbaText: string = 'rgba(165, 26, 214, 0.2)';

  public arrayColors: any = {
    color1: '#2883e9',
    color2: '#e920e9',
    color3: 'rgb(255,245,0)',
    color4: 'rgb(236,64,64)',
    color5: 'rgba(45,208,45,1)'
  };

  public selectedColor: string = 'color1';

  public color1: string = '#2889e9';
  public color2: string = '#e920e9';

  public color3: string = '#ff0000';
  public color4: string = '#000000';

  // OBJASNUVANJE color 3 = fillcolor 
  // OBJASNUVANJE color 4 = strokecolor 

  public cmykColor: Cmyk = new Cmyk(0, 0, 0, 0);

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, private cpService: ColorPickerService, public toastCtrl: ToastController) {
    this.poigr = this.navParams.get('poigroup')
    this.cb = navParams.get('cb');
    //debugger

    if (this.poigr.id == -1) {
      this.Title = this.dic.l["newpoigroup"]
      this.color2 = '#1b1a1b'
      this.color3 = '#ff0000'

    } else {
      this.Title = this.dic.l["editpoigroup"]
      this.name = this.poigr.name
      this.color2 = this.poigr.appcolor
      this.color3 = this.poigr.fillcolor
      // this.color4 = this.poigr.strokecolor

      if (this.color2 != null && this.color2 != '') {
        this.boja = true
      }
      if (this.color2 == null || this.color2 == '') {
        this.color2 = '#1b1a1b'
      }
    }
  }

  public onEventLog(event: string, data: any): void {
    console.log(event, data);
  }

  public onChangeColorCmyk(color: string): Cmyk {
    const hsva = this.cpService.stringToHsva(color);

    if (hsva) {
      const rgba = this.cpService.hsvaToRgba(hsva);

      return this.cpService.rgbaToCmyk(rgba);
    }

    return new Cmyk(0, 0, 0, 0);
  }

  public onChangeColorHex8(color: string): string {
    const hsva = this.cpService.stringToHsva(color, true);

    if (hsva) {
      return this.cpService.outputFormat(hsva, 'rgba', null);
    }

    return '';
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditgrouppoiPage');
  }

  Save() {
    if (this.name == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterpoigroupname"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    if (this.boja == false) {
      this.color2 = ''
    }

    var _that = this;
    var dat = {
      gname: this.gn.crypt(this.name),
      cid: this.gn.crypt(this.gn.user.ClientId),
      color: this.gn.crypt(this.color2),
      fillcolor: this.gn.crypt(this.color3),

    }
    //this.gn.disableBtn();
    this.gn.tfBtn = true;
    this.gn._Post('/api/gn/addpoigrouop', dat, function (_data) {
      _that.navCtrl.pop();
      _that.cb();
      _that.gn.tfBtn = false;
    })
    //debugger
  }

  Edit() {
    if (this.boja == false) {
      this.color2 = ''
    }
    var _that = this;
    var dat = {
      gid: this.gn.crypt(this.poigr.id),
      gname: this.gn.crypt(this.name),
      cid: this.gn.crypt(this.gn.user.ClientId),
      color: this.gn.crypt(this.color2),
      fillcolor: this.gn.crypt(this.color3),
      // strokecolor: this.gn.crypt(this.color4)

    }

    this.gn.tfBtn = true;
    this.gn._Post('/api/gn/editpoigrouop', dat, function (_data) {
      _that.navCtrl.pop();
      _that.cb();
      _that.gn.tfBtn = false;
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/poisettings/editgrouppoi.ts